import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //Basic Commodity:1
  //Goods:2
  //Services:3
  value: "2",
};

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCategory } = categorySlice.actions;

export default categorySlice.reducer;
